import React from 'react';
import { Box, Stack, TextField } from '@mui/material';
import TopBar from '../../../components/TopBar';
import SubscriptionListPageActions from '../components/SubscriptionListPageActions';
import SubscriptionsTable from '../components/SubscriptionsTable';
import useSubscriptionFilters from '../components/SubscriptionFilterHelper';

export default function SubscriptionListPage() {
  const { searchTerm, currentQuery, pagination, handleSearchChange, handleSearchKeyDown, handlePaginationChange } =
    useSubscriptionFilters({ defaultQuery: {} });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Subscriptions">
        <SubscriptionListPageActions />
      </TopBar>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <TextField
          label="Search by name or email"
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={(event) => handleSearchChange(event.target.value)}
          onKeyDown={handleSearchKeyDown}
          size="small"
          sx={{ width: 320 }}
        />
      </Box>
      <SubscriptionsTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
        paginationModel={{ page: pagination.page, pageSize: pagination.size }}
      />
    </Stack>
  );
}
